<template>
  <div>
    <div class="container-fluid">
      <div class="row">
          Verifying email ...
        <!-- <div class="col-12">
          <div class="verifyblock border">
            <div class="avatar">
              <span class="icon-dotted-spinner border-grey-dark font-40 mr-3 animate"></span>
            </div>
            <div class="title font-30 border-grey-dark ml-3">
              Verifying email ...
            </div>
          </div>
        </div> -->
      </div>
    </div>
    
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
export default {
  name: "VerifyEmail",

  watch:{
    '$route':{
      handler(newVal){
        if(newVal)
          this.emailVerification();
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    ...mapGetters(["getAuthUser"]),
  },
  methods:{
    ...mapActions(["verifyEmail"]),
    getAccountType(getMessage){
        if(this.getAuthUser){
          console.log('logged in');
          localStorage.setItem("emailVerificationMessage",JSON.stringify(getMessage));
          let account=this.getAuthUser.cap_token.slice(-1);
          if(account==="0") location.href="/school/dashboard";
          else if(account==="1") location.href="/teacher/feeds";
          else if(account==="2") location.href="/parent/feeds";
          else if(account==="3") location.href="/student/feeds";

        }else{
          console.log('not logged in',JSON.stringify(getMessage));
          document.cookie=`emailVerificationMessage=${JSON.stringify(getMessage)}`;
          this.$router.push({name:"GradelyLogin"});
        }
    },

    emailVerification(){
      
      this.verifyEmail(this.$route.query.token).then((response)=>{
        if (response.code===200 ){
          console.log(response);
          setTimeout(()=>{
            let message={
              type:"success",
              message:"Email verification successful"
            };
            this.getAccountType(message);
            
          },2000);
        }else{
          console.log(response);
          setTimeout(() => {
            let message={
              type:"error",
              message:"Email verification token has expired"
            };
            this.getAccountType(message);
          }, 2000);
        }
          
      }).catch((error)=>{
        console.log(error);
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  .container{
    height: 100vh;
    width: 100vw;
    .verifyblock{
      // @include transform_center
    }
  }
</style>
